import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

const EditVehicleTypeModal = ({ isOpen, onClose, editFormData, setEditFormData, id, sa }) => {
  if (!isOpen) return null;

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
        Swal.fire({
                    title: "Submitting...",
                    text: "Please wait while we process your request.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
      const response = await axios.put(`https://rfs2.infraconsoft.net.in/api/edit_veh_type_main`, {
        subAssembly: editFormData.subAssembly,
        subId: editFormData.subId,
        qty: editFormData.qty,
        partNo: editFormData.partNo,
        spec: editFormData.spec,
        desc: editFormData.desc,
        usage: editFormData.usage,
        id: id,
        mainId :editFormData.mainId

        
      });

      if (response.data.success) {
              Swal.fire({
                icon: "success",
                title: "Inserted!",
                text: "sub Assembly Updated successfully.",
              });
              onClose();
              window.location.reload();
            } else {
              Swal.fire({
                icon: "error",
                title: "Update Failed",
                text: response.data.message || "Unknown error.",
              });
            }
        
          } catch (error) {
            console.error("Error Update:", error);
        
            if (error.response) {
              console.error("Error Response Data:", error.response.data);
            }
        
            if (error.response && error.response.data && error.response.data.message) {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error.response.data.message,
              });
            } else {
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Update failed. Please try again.",
              });
            }
          }
        };

  return (
    <div className="modal">
      <div className="modal-content" style={{ position: "relative" }}>
      <div style={{ position: "absolute", top: "10px", right: "10px" }}>
        <button className="close-btn" onClick={onClose} style={{position: "initial"}}>&times;</button>
    </div>
        <h3>Edit Sub Assembly</h3>
        <form className="vehicle-form" onSubmit={handleEditSubmit}> 

        <div className="form-row">
            <div className="form-group">
              <label>Sub Assembly :</label>
              <select
                name="subAssembly"
                value={editFormData.subAssembly}
                onChange={handleEditChange}
                required
              >
                <option value="">-Select-</option>
                {sa.map((item, index) => (
                  <option
                    key={index} value={item.fld_subassembly}
                  >
                    {item.fld_subassembly}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="form-row">
              <div className="form-group">
                <label>Desc :</label>
                <input type="text" name="desc" value={editFormData.desc} onChange={handleEditChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Part No :</label>
                <input type="text" name="partNo" value={editFormData.partNo} onChange={handleEditChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Specification :</label>
                <input type="text" name="spec" value={editFormData.spec} onChange={handleEditChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Qty :</label>
                <input type="text" name="qty" value={editFormData.qty} onChange={handleEditChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Usage Limit :</label>
                <input type="text" name="usage" value={editFormData.usage} onChange={handleEditChange} />
              </div>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                 Update
              </button>
            </div>
           
            </form>

      </div>
    </div>
  );
};

export default EditVehicleTypeModal;
